import { ServiceCallLog } from './store/schema/FormsDiagnosticsStore';

import { LazyImport, LazyModule } from 'owa-bundling';

export { ServiceCallLog };

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FormsDiagnostics", webpackPrefetch: true */ './lazyIndex')
);

export const lazyLogServiceCallForDiagnostics = new LazyImport(
    lazyModule,
    m => m.logServiceCallForDiagnostics
);
